var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MetricType, forHumans } from "@madmedical/medical";
import useResponsive from "../../util/useResponsive";
import DailyStepsMobile from "./Mobile/DailyStepsMobile";
import HeartRateMobile from "./Mobile/HeartRateMobile";
import BloodOxygen from "./Desktop/BloodOxygen";
import BloodPressure from "./Desktop/BloodPressure";
import BloodSugar from "./Desktop/BloodSugar";
import BodyTemperature from "./Desktop/BodyTemperature";
import BodyWeight from "./Desktop/BodyWeight";
import DailySteps from "./Desktop/DailySteps";
import HeartRate from "./Desktop/HeartRate";
import BodyMassIndexMobile from "./Mobile/BodyMassIndexMobile";
import BodyMassIndex from "./Desktop/BodyMassIndex";
const MeasurementProtocolModalForm = (_a) => {
    var { metricType } = _a, restProps = __rest(_a, ["metricType"]);
    const { isSmallScreen } = useResponsive();
    switch (metricType) {
        case MetricType.BloodOxygen:
            return _jsx(BloodOxygen, Object.assign({}, restProps));
        case MetricType.BloodPressure:
            return _jsx(BloodPressure, Object.assign({}, restProps));
        case MetricType.BloodSugar:
            return _jsx(BloodSugar, Object.assign({}, restProps));
        case MetricType.BodyMassIndex:
            return isSmallScreen ? (_jsx(BodyMassIndexMobile, Object.assign({}, restProps))) : (_jsx(BodyMassIndex, Object.assign({}, restProps)));
        case MetricType.BodyTemperature:
            return _jsx(BodyTemperature, Object.assign({}, restProps));
        case MetricType.BodyWeight:
            return _jsx(BodyWeight, Object.assign({}, restProps));
        case MetricType.DailySteps:
            return isSmallScreen ? (_jsx(DailyStepsMobile, Object.assign({}, restProps))) : (_jsx(DailySteps, Object.assign({}, restProps)));
        case MetricType.RestingHeartRate:
            return isSmallScreen ? (_jsx(HeartRateMobile, Object.assign({}, restProps))) : (_jsx(HeartRate, Object.assign({}, restProps)));
        default:
            throw `Threshold edit not supported for ${forHumans(metricType)}`;
    }
};
export default MeasurementProtocolModalForm;
